import { css } from '../../styles/theme';
import { rem } from 'polished';

export const StylesAP = css`
    &:first-child a {
        color: ${({ theme }) => theme.colors.black} !important;

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary} !important;
        }
    }
`;
